import { render, staticRenderFns } from "./Biologia.vue?vue&type=template&id=f68f8724&scoped=true"
import script from "./Biologia.vue?vue&type=script&lang=js"
export * from "./Biologia.vue?vue&type=script&lang=js"
import style0 from "./Biologia.vue?vue&type=style&index=0&id=f68f8724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68f8724",
  null
  
)

export default component.exports